import { Grid, Box } from "@mui/material";
import theme from "../../../assets/theme";
import FaiBox from "../../../MuiComponents/FaiBox";
import FaiButton from "../../../MuiComponents/FaiButton";
import FaiTypography from "../../../MuiComponents/FaiTypography";
import { useCallback } from "react";
import DraftIlustration from "../../../assets/images/illustrations/drafts.png";
import AddIcon from "@mui/icons-material/Add";

function NoDraft() {
	const { typography, palette, borders } = theme;

	const addProduct = useCallback(() => {
		// Navigate to add product page
		window.location.href = "/app/catalog/add-product";
	}, []);

	return (
		<FaiBox 
			display="flex" 
			justifyContent="center" 
			alignItems="center" 
			p={6}
			height="400px"
		>
			<Grid container spacing={4} alignItems="center" justifyContent="center">
				<Grid item xs={12} md={7} lg={6}>
					<FaiBox>
						<Box
							component="img"
							src={DraftIlustration}
							alt="No drafts illustration"
							sx={{
								width: "100%",
								maxWidth: "400px",
								height: "auto",
								display: "block",
								margin: "0 auto 24px"
							}}
						/>
					</FaiBox>
				</Grid>
				<Grid item xs={12} md={5} lg={6}>
					<FaiBox textAlign={{ xs: "center", md: "left" }}>
						<FaiTypography 
							variant="h4" 
							fontWeight={typography.fontWeightBold}
							gutterBottom
						>
							No Draft Listings Found
						</FaiTypography>
						<FaiTypography 
							variant="body1" 
							color="text.secondary" 
							mb={3}
							sx={{ maxWidth: "500px" }}
						>
							You haven't created any draft listings yet. Start by adding a product to create your first listing.
						</FaiTypography>
						<FaiButton
							variant="contained"
							color="primary"
							onClick={addProduct}
							startIcon={<AddIcon />}
							sx={{ 
								py: 1.2,
								px: 3,
								boxShadow: "0 4px 14px 0 rgba(0,171,85,0.4)",
								"&:hover": {
									boxShadow: "0 6px 18px 0 rgba(0,171,85,0.5)"
								}
							}}
						>
							Add a Product
						</FaiButton>
					</FaiBox>
				</Grid>
			</Grid>
		</FaiBox>
	);
}
export default NoDraft;
